import React, {Component} from 'react';
import styled from 'styled-components';

import {HeadlineH1} from './text/Headlines';
import {RCol, Row} from './Grid';
import {TopBar, TopBarButton, TopBarLeftCol} from './form/FormElements';
import CEDownload from './CEDownload';
import ErrorMessage from './ErrorMessage';
import WindowParams from './WindowParams';
import WindowSearchResult from '../containers/WindowSearchResult';
import filterOutNotDefinedValues from '../helpers/filterOutNotDefinedValues';

const ToggleSearch = styled.div`
  cursor: pointer;
  color: grey;
  font-weight: bold;
`;
const initialState = {
  showOptions: true,
  search: false,
  name: '',
  winType: null,
  winClass: null,
  variation: null,
  uValueFrame: null,
  uValueGlass: null,
  windLoad: null,
  drivingRain: null,
  psiValue: null,
  rainRackType: null,
  coatingType: null,
  wingSeal: null,
  foldSeal: null,
  glassType: null,
  placeholder: null,
  rainRackProd: null,
  coatingProd: null,
  sealProd: null,
  profileDie: null,
  airPermeable: null,
  operateForce: null,
  mechanicalStress: null,
  thermalInsulation: null,
  soundInsulation: null,
  serialNumber: '',
  qualityReportNumber: '',
  height: '',
  width: '',
  completeSurface: '',
};
export default class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initialState,
      ...filterOutNotDefinedValues(props.data.window),
    };
  }

  componentWillReceiveProps = newProps => {
    if (newProps.data.error) {
      const {graphQLErrors} = newProps.data.error || {};
      this.setState({errors: graphQLErrors});
    } else {
      const {window} = newProps.data || {};
      this.setState({errors: [], ...filterOutNotDefinedValues(window)});
    }
  };
  _goBackToList = () => this.props.history.replace('/window');

  _renderHeadline = () => {
    return <HeadlineH1>Fenster suchen</HeadlineH1>;
  };
  _search = () => {
    this.setState({search: true, showOptions: false});
  };
  _handleChange = ({key, value}) => {
    this.setState({[key]: value, search: false});
  };
  _handleTextValueChange = (key, value) => {
    this.setState({[key]: value});
  };
  _showFilter = () => {
    this.setState({
      showOptions: true,
    });
  };
  _clearSearch = () => {
    this.setState(initialState);
  };
  render() {
    let {errors, _id, search, showOptions, ...searchOptions} = this.state;

    return (
      <div>
        <TopBar>
          <Row>
            <TopBarLeftCol size={0.3} style={{paddingLeft: 100}}>
              <HeadlineH1>Fenster suchen</HeadlineH1>
            </TopBarLeftCol>
            <RCol size={0.7}>
              <CEDownload />
              <TopBarButton default onClick={this._search} label="Suchen" />
              <TopBarButton default onClick={this._clearSearch} label="Suche zurücksetzen" />
            </RCol>
          </Row>
        </TopBar>
        <ErrorMessage errors={errors} />
        {showOptions && (
          <div>
            <WindowParams
              metas={this.props.data.allMetas}
              showAdd={false}
              handleChange={this._handleChange}
              handleTextValueChange={this._handleTextValueChange}
              {...this.state}
            />
          </div>
        )}
        {!showOptions && <ToggleSearch onClick={this._showFilter}>Suchfilter einblenden</ToggleSearch>}
        {search && <WindowSearchResult user={this.props.user} searchOptions={searchOptions} />}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/WindowSearch.js